import { Subject } from 'rxjs';

export default new Subject<string>();
